var $e73bf42412feb220$exports = {};
const $e73bf42412feb220$var$dateFormat = new Intl.DateTimeFormat('en-UK', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});
const $e73bf42412feb220$var$currentDate = $e73bf42412feb220$var$dateFormat.format(new Date());
var $e73bf42412feb220$var$pattern = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a'
];
var $e73bf42412feb220$var$current = 0;
var $e73bf42412feb220$var$keyHandler = function(event) {
    // If the key isn't in the pattern, or isn't the current key in the pattern, reset
    if ($e73bf42412feb220$var$pattern.indexOf(event.key) < 0 || event.key !== $e73bf42412feb220$var$pattern[$e73bf42412feb220$var$current]) {
        $e73bf42412feb220$var$current = 0;
        return;
    }
    // Update how much of the pattern is complete
    $e73bf42412feb220$var$current++;
    // If complete, alert and reset
    if ($e73bf42412feb220$var$pattern.length === $e73bf42412feb220$var$current) {
        $e73bf42412feb220$var$current = 0;
        window.alert('ah bah super');
    }
};
// Listen for keydown events
document.addEventListener('keydown', $e73bf42412feb220$var$keyHandler, false); // Check if page is Next Shows
 // var isShowsPage = document.getElementsByClassName('shows');
 // // Loop through shows
 // if (isShowsPage.length > 0) {
 // 	var showItems = document.getElementsByClassName('show-item');
 // 	for(var i = 0; i < showItems.length; i++) {
 //         var thisShow = showItems[i].getElementsByClassName('date');
 //         var thisShowDate = thisShow[0].innerHTML;
 //         // var thisShowDate = new Date(thisShow[0].innerHTML);
 //         // var thisShowDate = dateFormat.format(new Date(thisShow[0].innerHTML));
 //         console.log(currentDate + ' ' + thisShowDate);
 //         if (Date.parse(currentDate) < Date.parse(thisShowDate)) {
 //             showItems[i].classList.add('expired');
 //         }
 // 	}
 // }


//# sourceMappingURL=doomnooyelbek-links.c0ae8ffe.js.map
